import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isModalOpen: false,
    modalContent: null,
    modalContentProps: null,
    isOnline: navigator.onLine,
    isSyncing: false,
    syncProgress: { completed: 0, total: 0 },
};
const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        setIsModalOpen: (state, action) => {
            state.isModalOpen = action.payload;
        },
        setModalContent: (state, action) => {
            state.modalContent = action.payload;
        },
        setModalContentProps: (state, action) => {
            state.modalContentProps = action.payload;
        },
        setIsOnline: (state, action) => {
            state.isOnline = action.payload;
        },
        setIsSyncing: (state, action) => {
            state.isSyncing = action.payload;
        },
        setSyncProgress: (state, action) => {
            state.syncProgress = action.payload;
        },
    },
    selectors: {
        selectIsModalOpen: (state) => state.isModalOpen,
        selectModalContent: (state) => state.modalContent,
        selectModalContentProps: (state) => state.modalContentProps,
        selectIsOnline: (state) => state.isOnline,
        selectIsSyncing: (state) => state.isSyncing,
        selectSyncProgress: (state) => state.syncProgress,
    },
});
export const { setIsModalOpen, setModalContent, setModalContentProps, setIsOnline, setIsSyncing, setSyncProgress, } = globalSlice.actions;
export const { selectIsModalOpen, selectModalContent, selectModalContentProps, selectIsOnline, selectIsSyncing, selectSyncProgress, } = globalSlice.selectors;
export default globalSlice.reducer;
